<p>bank-payment-view works!</p>
